import { axios } from '@util';

class OrphanClaims {
  /**
   * Get the collection of orphan claims via the Django proxy.
   *
   * @param {string} role The role.
   * @param {string} roleValue The role value.
   * @param {object} params The parameters.
   * @param cancellableSource Optional axios cancel token source.
   * @returns Promise
   */
  async getOrphanClaims(role, roleValue, { search, page, page_size, approved }, signal) {
    return await axios({
      url: '/lincoln/api/get/orphan-claims/',
      method: 'POST',
      params: {
        ...(search ? { search } : null),
        page: page || 1,
        page_size: page_size || 10,
      },
      data: {
        role: role,
        role_value: roleValue,
        approved: approved || false,
      },
      ...(signal ? { signal } : null),
    });
  }

  /**
   * Deletes items from the collection of orphan claims via the Django proxy.
   * Broker users will receive a 403 response.
   *
   * @param {array<number>} ids The array of data row ids.
   * @returns Promise
   */
  async deleteOrphanClaims(ids = []) {
    return await axios({
      url: '/lincoln/api/delete/orphan-claims/',
      method: 'POST',
      data: {
        data_row_ids: ids,
      },
    });
  }

  /**
   * Approves or unapproves orphan claims via the Django proxy.
   * Broker users will receive a 403 response.
   *
   * @param {boolean} approved Whether to approve or unapprove.
   * @param {array<number>} ids The array of data row ids.
   * @returns Promise
   */
  async approveOphanClaim(approved, ids = []) {
    return await axios({
      url: '/lincoln/api/update/orphan-claims/',
      method: 'POST',
      data: {
        data_row_ids: ids,
        approved,
      },
    });
  }
}

export default new OrphanClaims();
